import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function LoadingPanel (props) {
    return (
        <ListItem>
            <ListItemIcon>
                <CircularProgress size={24} color="secondary" />
            </ListItemIcon>
            <ListItemText primary={props.message} />
        </ListItem>
    );
}